// Types
import type { TApiHttpClientRequestConfig, TPaginated } from '~/misc/resource/types';
import type {
  TAutomatedEmailSentApiRow,
  TAutomatedEmailSentListQuery,
  TSentEmail,
} from '~/modules/opportunities/automated-email/types';

// Models
import { DefaultResource } from '~/misc/resource/default-resource.model';

// Utils
import { mapAutomatedEmailSentApiRow } from '~/modules/opportunities/automated-email/utils/map-sent-api';

export class SentModel extends DefaultResource {
  protected endpoint: string = 'automated-email/';

  getSent(
    query: TAutomatedEmailSentListQuery,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginated<TSentEmail>> {
    return this
      .get<TPaginated<TAutomatedEmailSentApiRow>>('sent', query, requestConfig)
      .then((res: TPaginated<TAutomatedEmailSentApiRow>): TPaginated<TSentEmail> => ({
        data: res.data.map(mapAutomatedEmailSentApiRow),
        meta: res.meta,
      }));
  }
}
